import { ImagePreviewComponent } from './image-preview.component';

declare let angular: ng.IAngularStatic;

export default angular
  .module('sfMobile.components.image-preview', [])
  .component('sfImagePreview', ImagePreviewComponent).name;
